// extracted by mini-css-extract-plugin
export default {"header":"txNiOrXESf","headerText":"T68lTRA2EH","viewAllCommentsLink":"esZYgvRl6L","loadMoreIndicatorContainer":"CUjT9szQNB"};